import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KinoBookingInvoiceResponse } from '../../models/kino-booking.model';
import * as moment from 'moment';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-kino-inovice-print',
  templateUrl: './kino-inovice-print.component.html',
  styleUrls: ['./kino-inovice-print.component.scss']
})
export class KinoInovicePrintComponent implements OnInit
{
  mymoment = moment;

  imgFile;
  imgLoaded = false;

  constructor(
    public dialogRef: MatDialogRef<KinoInovicePrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: KinoBookingInvoiceResponse,
    private helper: HelperService
  )
  {
    this.mymoment().locale('de');
  }

  ngOnInit()
  {
    console.log('Data', this.data);

    if (this.data.qr_image)
    {
      this.imgFile = 'data:image/png;base64,' + this.data.qr_image;
    }
    else if (this.data.qr_url)
    {
      this.helper.getBase64ImageFromUrl(this.data.qr_url)
        .then(result =>
        {
          this.imgFile = result;
        })
        .catch(err => console.error(err));
    }
    else
    {
      this.imgFile = null;
      this.imgLoaded = true;
      setTimeout(() => {
        this.printInvoice();
      }, 100);
    }
  }

  printInvoice()
  {
    try
    {
      this.imgLoaded = true;
      const div = document.getElementById('print-content');

      const mywindow = window.open('', '_blank');

      mywindow.document.write('<html><head><title>' + document.title + '</title><style>*{font-size:10px}body{width: 1.8in; font-family:Arial} table{width:100%}</style>');
      mywindow.document.write('</head><body>');
      mywindow.document.write(div.innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      // this.dialogRef.close();
    }
    catch (error)
    {
      console.log('Error has occured when trying to open a new tab: \n\n', error);
    }
  }
}
